import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { values, map, noop, includes } from 'lodash'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import Form from '../../../components/forms/form'
import CommentListItem from './comment_list_item'

export default class CommentsList extends PureComponent {
  handleSelect = (commentId, selected) => {
    const { onSelect } = this.props
    onSelect(commentId, selected)
  }

  getRows() {
    const { comments, selectedIds } = this.props
    return map(values(comments), comment => {
      const commentId = comment.id
      const isChecked = includes(selectedIds, commentId)
      return (
        <CSSTransition key={`comment-list-item-transition-${commentId}`} classNames="fade-in-out" timeout={600}>
          <CommentListItem
            key={`comment-list-item-${commentId}`}
            comment={comment}
            onSelect={this.handleSelect}
            isChecked={isChecked}
          />
        </CSSTransition>
      )
    })
  }

  render() {
    const { comments, formAction } = this.props
    if (comments.length === 0) {
      return (
        <div className="comments-list">
          <p>No comments to display.</p>
        </div>
      )
    }
    const rows = this.getRows()
    return (
      <div className="comments-list">
        <Form action={formAction} ignoreMissingSubmitHandler={true}>
          <ul className="unstyled-list moderation-comments-list">
            <TransitionGroup>{rows}</TransitionGroup>
          </ul>
        </Form>
      </div>
    )
  }
}
CommentsList.propTypes = {
  comments: PropTypes.array.isRequired,
  selectedIds: PropTypes.array.isRequired,
  formAction: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
}
CommentsList.defaultProps = {
  comments: [],
  selectedIds: [],
  onSelect: noop,
}
